import { render, staticRenderFns } from "./SearchBasic.vue?vue&type=template&id=191c3861&scoped=true&"
import script from "./SearchBasic.vue?vue&type=script&lang=js&"
export * from "./SearchBasic.vue?vue&type=script&lang=js&"
import style0 from "./SearchBasic.vue?vue&type=style&index=0&id=191c3861&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191c3861",
  null
  
)

export default component.exports